export default "__VITE_ASSET__BTSAC1VW__"